import { NgxSpinnerService } from "ngx-spinner";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";

import { Sensor } from "../../models/Sensor.model";
import { Validation } from "./validation";
import storageX from "../../storageCore/storageX";
import {
  STORAGE_KEY_CURRENT_USER,
  STORAGE_KEY_ID_PERFIL,
} from "../../storageCore/constStorageKeys";
import { ApiBaseService } from "../../services/migrate/api.base.service";
import { Company } from "src/app/models/Company.model";

@Component({
  selector: "app-create-sensor",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.scss"],
})
export class CreateSensorComponent implements OnInit {
  public atualizarEmpresa = false;
  public sensorForm: FormGroup;
  public title = "Cadastrar Sensor";
  public errorMessage;
  private apiBaseService: ApiBaseService;
  private validation: Validation;
  public empresaUpdateSelected = true;

  public empresaSelected;
  public empresaFilterSelected;

  public companies: any = [];
  public companiesFilter: any = [];
  public companiesSelect: any = [
    { name: "Divisão", value: 1 },
    { name: "Matriz", value: 2 },
    { name: "Filial", value: 3 },
  ];

  ngOnInit(): void {
    this.sensorForm = this.formBuilder.group(this.validation.rules());

    this.setup();
  }

  constructor(
    apiBaseService: ApiBaseService,
    private formBuilder: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {
    this.apiBaseService = apiBaseService;
    this.validation = new Validation();
  }

  async setup(): Promise<void> {
    try {
      const params = {
        size: 999999,
        page: 0,
        profileId: storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get(),
      };

      const result = await this.apiBaseService.get<any>({
        url: new Company()["nomeConsultaApiBaseGetAll"],
        params,
      });

      this.companies = result["content"];

      this.spinner.hide();
    } catch (error) {
      console.error(error);
    }
  }

  public filterCompany() {
    var idEmpresa = this.empresaFilterSelected;
    var empresas = [];

    if (idEmpresa == "Divisão") {
      this.companies.forEach((element) => {
        if (element.cnpj == null) {
          empresas.push(element);
        }
      });
    }

    if (idEmpresa == "Matriz") {
      this.companies.forEach((element) => {
        if (element.cnpj != null && element.idEmpresaMatriz == null) {
          empresas.push(element);
        }
      });
    }

    if (idEmpresa == "Filial") {
      this.companies.forEach((element) => {
        if (element.cnpj != null && element.idEmpresaMatriz != null) {
          empresas.push(element);
        }
      });
    }

    this.companiesFilter = empresas;
  }

  public async submitForm(): Promise<void> {
    this.spinner.show();
    try {
      this.coverterUpperCase(this.sensorForm);
      const values = this.sensorForm.value;
      var post;

      if (this.empresaFilterSelected != "Divisão") {
        post = {
          codigoSensor: values.codigoSensor,
          empresa: {
            id: parseInt(values.idEmpresa),
          },
          divisao: null,
          idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
        };
      } else {
        post = {
          codigoSensor: values.codigoSensor,
          divisao: {
            id: parseInt(values.idEmpresa),
          },
          empresa: null,
          idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
        };
      }

      await this.apiBaseService.post<Sensor>(
        new Sensor()["nomeConsultaApiBase"],
        post
      );
      this.spinner.hide();
      this.router.navigate(["/sensor"]);
    } catch (error) {
      this.spinner.hide();
      this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  public coverterUpperCase(sensorForm: FormGroup) {
    sensorForm
      .get("codigoSensor")
      .setValue(sensorForm.get("codigoSensor").value.toUpperCase());
  }
}
